import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "./lib/useContent";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Category from "./pages/Category";
import Contact from "./pages/Contact";

const AdminLayout    = lazy(() => import("./pages/admin/AdminLayout"));
const ContentEditor  = lazy(() => import("./pages/admin/ContentEditor"));
const ContactInbox   = lazy(() => import("./pages/admin/ContactInbox"));

function App() {
    return (
        <ContentProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Layout><Home /></Layout>} />
                        <Route path="/about" element={<Layout><About /></Layout>} />
                        <Route path="/portfolio" element={<Layout><Portfolio /></Layout>} />
                        <Route path="/portfolio/:slug" element={<Layout><Category /></Layout>} />
                        <Route path="/contact" element={<Layout><Contact /></Layout>} />
                        <Route path="/admin/*" element={
                            <Suspense fallback={<div style={{ padding: 24, color: '#7A6D7D' }}>Loading admin…</div>}>
                                <AdminLayout />
                            </Suspense>
                        }>
                            <Route index element={<Navigate to="content" replace />} />
                            <Route path="content"  element={<ContentEditor />} />
                            <Route path="contacts" element={<ContactInbox />} />
                        </Route>
                    </Routes>
                    <Toaster
                        position="bottom-center"
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: "#120D14",
                                color: "#F7F2F8",
                                border: "1px solid #241B26",
                                borderRadius: 0,
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "12px",
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                            },
                        }}
                    />
                </BrowserRouter>
            </div>
        </ContentProvider>
    );
}

export default App;
